import axios from "axios"
import { ACCESS_TOKEN, BACKEND_URL } from "./constants.js";

const api = axios.create({
    baseURL: BACKEND_URL
})

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(ACCESS_TOKEN)
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default api
